export const ZIP_CODE_COUNT_BY_COUNTRY = Object.freeze({
  DE: 5,
  AT: 4,
  CH: 4,
  PL: 6,
});
